import React from "react";
import { Outlet } from "react-router-dom";
import "./Layout.scss";

export default function Layout() {
  return (
    <div className="row">
      <div className="col-12 col-md-8 col-lg-6 offset-md-2 offset-lg-3">
        <div className="password-reset-email loading-overlay-wrapper background-color--bright">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
